import React from 'react';
import cn from "classnames";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import styles from "./banner-info.css";

SwiperCore.use([Autoplay, Pagination])

const BannerInfo = ({ classInfo, isJoined, buttons, onExit, type = 'student',teacher }) => {
    return (
        <div className={styles.bannerBg}>
            <div className={styles.classBanner}>
                <div className={styles.classContent}>
                    <div className={styles.className}>{classInfo.name}</div>
                    <div className={styles.school}>
                        {
                            type === 'teacher' &&
                            <div className={styles.classCode}>
                                <p>班级码：{classInfo.code}</p>
                                <span>/</span>
                            </div>
                        }
                        <p>所属学校：{classInfo.school_name ? classInfo.school_name : '无'}</p>
                        <span>/</span>
                        <p>任课老师：{teacher}</p>
                    </div>
                    <div className={styles.desc}>{classInfo.desc ? classInfo.desc : '暂无介绍'}</div>
                    <div className={styles.operateBtn}>
                        {buttons}
                        <div>
                            {type === 'student' && isJoined && <span className={styles.exitClass} onClick={onExit}>退出班级</span>}
                            {type === 'teacher' && <span className={styles.exitClass} onClick={onExit}>解散班级</span>}
                        </div>
                    </div>
                </div>
                <div className={styles.classSwiper}>
                    <Swiper
                    // spaceBetween={0}
                    // loop={true}
                    // autoplay
                    // pagination
                    // autoHeight={true}
                    >
                        <SwiperSlide style={{ height: '300px', width: '400px' }}><img src={classInfo.cover || `${window.config.staticURL}/cover/class/default.png` || require('../../../../static/course-cover-default.svg')} /></SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    )
};

export default BannerInfo;
